module.exports = __webpack_public_path__ + "img/saum_karminrot_ral3002.676c3eaf.jpg";